import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Maybe } from "graphql/jsutils/Maybe";
import type { FC, ReactNode } from "react";
import { DownloadBundle, DownloadPart, FlowInput } from "../../graphql/types";
import { DownloadBundleRow } from "../DownloadBundleRow";
import { DownloadRow } from "../DownloadRow";
import { DateCol, StatusTh } from "../ui/muiTables";

const DOWNLOADED = ["processing", "uploading", "succeeded"];

interface DownloadsProps {
  inputs: Maybe<FlowInput>[];
  testFlowPhase: string;
}

const TestFlowDownloads: FC<DownloadsProps> = ({ inputs, testFlowPhase }) => {
  const downloads: ReactNode[] = [];
  if (inputs) {
    inputs.forEach((input) => {
      if (input?.download_part || input?.download) {
        downloads.push(
          <DownloadRow
            sourceTable={input.source_table}
            bundle={input.download as DownloadBundle}
            part={input.download_part ? (input.download_part as DownloadPart) : undefined}
            key={input.download_part ? input.download_part.id : input.download?.id}
          />
        );
      } else {
        if (DOWNLOADED.indexOf(testFlowPhase) === -1 && input?.source_table) {
          downloads.push(<DownloadBundleRow downloadBundle={input?.source_table} key={input.source_table.name} />);
        }
      }
    });
  }
  if (downloads.length === 0) {
    downloads.push(
      <tr key="0">
        <td colSpan={7} className="tableMessage">
          No Downloads
        </td>
      </tr>
    );
  }
  return (
    <TableContainer component={Paper}>
      <Table className="table-striped table-condensed" stickyHeader data-cy="flows-table">
        <TableHead>
          <TableRow>
            <DateCol>Report Date</DateCol>
            <DateCol>Found</DateCol>
            <DateCol>Started</DateCol>
            <DateCol>Finished</DateCol>
            <TableCell>Description</TableCell>
            <TableCell></TableCell>
            <StatusTh>Status</StatusTh>
          </TableRow>
        </TableHead>
        <TableBody>{downloads}</TableBody>
      </Table>
    </TableContainer>
  );
};

export { TestFlowDownloads };
